import React, { useEffect, useState } from "react";
import ImageSwiper from "./image-swiper/Image_Swiper";
import Cruises_Policies from "./cruise_policies/Cruise_Policies";
import WhatsCoveredTrip from "./whats-covered-in-your-trip/Whats_Covered_In_Your_Trip";
import Cruise_Description from "./cruise_description/Cruise_Description";
import Itinerary from "./itinerary/Itinerary";
import Cruise_Booking from "./cruise_booking/Cruise_Booking";
import Success_Modal from "../../contact-us/success_modal/Success_Modal";
import { useParams } from "react-router-dom";
import { getData } from "../../../utils/api";

function Cruise_Details() {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { id } = useParams();
  const [packages, setPackage] = useState([]);

  const getPackageAll = async () => {
    const response = await getData(`/master/cruise-package/${id}/`);

    setPackage(response?.data);
  };

  useEffect(() => {
    getPackageAll();
  }, [id]);

  return (
    <>
      <ImageSwiper data={packages} />

      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <Cruise_Description data={packages} />
          </div>
          <div className="col-lg-4">
            <Cruise_Booking
              data={packages}
              onClick={() => {
                setShowSuccessModal(true);

                setTimeout(() => {
                  setShowSuccessModal(false);
                }, 3000);
              }}
            />
          </div>
        </div>
      </div>

      <WhatsCoveredTrip data={packages} />
      <Cruises_Policies data={packages} />

      <Success_Modal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        successText="Form Submitted!"
      />
    </>
  );
}

export default Cruise_Details;
